<div class="st-add-view-to-navigation-header">
    <mat-icon class="material-icons-outlined">bookmark_add</mat-icon>
    <div class="st-add-view-to-navigation-header-title">Add view to navigation</div>
</div>
<div class="st-add-view-to-navigation-body">
    <mat-form-field class="st-add-view-to-navigation-body-form-field">
        <mat-label>Group</mat-label>
        <mat-select
            [(value)]="selectedGroup"
            (selectionChange)="onSelectionChange()">
            @for (group of groups(); track group.ID) {
                <mat-option [value]="group">
                    {{ group.Label }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-selection-list
        [multiple]="false"
        [(ngModel)]="selectedSection">
        @for (section of sections; track section.ID) {
            <mat-list-option [value]="section">
                <div matListItemTitle>{{ section.Label }}</div>
            </mat-list-option>
        }
    </mat-selection-list>
</div>
<div class="st-add-view-to-navigation-footer">
    <button
        mat-button
        class="st-add-view-to-navigation-button-no"
        (click)="onCancelClick()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-button
        class="st-add-view-to-navigation-button-yes"
        cdkInitialFocus
        [disabled]="isConfirmDisabled"
        (click)="onConfirmClick()">
        {{ languageSettings.PSTWebConfirmButtonLabel }}
    </button>
</div>
